import React from "react";
import {
  Prewrap,
  SummaryField,
  SummaryFieldLabel,
  SummaryFieldContent,
} from "../styles";
import { getAnswer } from "../util";
import { NoteContentProps } from "./types";

export default function OutlierForm({ submission }: NoteContentProps) {
  const current_experience = getAnswer("current_experience", submission);
  const notes = getAnswer("notes", submission);
  const next_visit_notes = getAnswer("next_visit_notes", submission);
  return (
    <>
      {current_experience && (
        <SummaryField key="current_experience">
          <SummaryFieldLabel>Current experience</SummaryFieldLabel>
          <SummaryFieldContent>
            <Prewrap>{current_experience}</Prewrap>
          </SummaryFieldContent>
        </SummaryField>
      )}

      {notes && (
        <SummaryField key="notes">
          <SummaryFieldLabel>Assessment notes</SummaryFieldLabel>
          <SummaryFieldContent>
            <Prewrap>{notes}</Prewrap>
          </SummaryFieldContent>
        </SummaryField>
      )}

      {next_visit_notes && (
        <SummaryField key="next_visit_notes">
          <SummaryFieldLabel>Next visit notes</SummaryFieldLabel>
          <SummaryFieldContent>
            <Prewrap>{next_visit_notes}</Prewrap>
          </SummaryFieldContent>
        </SummaryField>
      )}
    </>
  );
}
